export default "https://cdn-static.gokick.com/assets/e388117c7865c86e8cffce5bc7abacefcd582b49/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";